import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import Actions_Wind from '~/Actions_Wind';
import { Dialog } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Upload } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';

const modeInfo = {
  add: {
    title: '行政契約產業關聯追蹤會議_新增',
  },
  edit: {
    title: '行政契約產業關聯追蹤會議_編輯',
  },
  view: {
    title: '行政契約產業關聯追蹤會議_檢視',
  },
};

class AddAndEdit extends Component {
  state={ data: {}, old_data: {}, mode: '', canSend: true, errorAry: [] }

  componentDidMount () {
    const { id, getIAMeetMeetingIdDetail, mode = '', getBaseData } = this.props;
    getBaseData();
    if (mode !== 'add')getIAMeetMeetingIdDetail(id);
  }

  componentDidUpdate (preProps) {
    const { IAMeetMeetingIdDetail: preIAMeetMeetingIdDetail = {} } = preProps;
    const { IAMeetMeetingIdDetail = {}, mode } = this.props;
    if (Object.keys(preIAMeetMeetingIdDetail).length === 0 && Object.keys(IAMeetMeetingIdDetail).length > 0 && (mode !== 'add')) {
      this.setState({ data: IAMeetMeetingIdDetail, old_data: IAMeetMeetingIdDetail });
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('IAMeetMeetingIdDetail');
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data = {} } = this.state;
    const body = {
      category: data.category,
      project: data.project,
      detailitem: data.detailitem || '',
      situation: data.situation,
      public_date: data.public_date,
      doc_num: data.doc_num,
      doc_subject: data.doc_subject,
      doc_upload_files: data.doc_upload_files || [],

      windcontract_id: Actions_Wind.wind_id(),
      admin_status: '0',
      form_status: '0',
    };
    return body;
  }

  add=() => {
    this.setState({ canSend: false });
    const body = this.getSendBody();
    this.props.postAddNewIAMeetMeeting(body);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    const { id, putIAMeetMeetingIdDetail } = this.props;
    this.setState({ canSend: false });
    const body = this.getSendBody();
    putIAMeetMeetingIdDetail(id, body);
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.category) === '',
      returnInputValue(data.project) === '',
      returnInputValue(data.detailitem) === '',
      returnInputValue(data.situation) === '',
      returnInputValue(data.public_date) === '',
      returnInputValue(data.doc_num) === '',
      returnInputValue(data.doc_subject) === '',
      (data.doc_upload_files || []).length === 0,
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const { mode = '', IAMMClassList = [], IAMMItemList = [] } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const isEdit = mode === 'edit';
    const disabled = mode === 'view' || isCheck;
    // const { status = '0' } = data;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const allRight = errorAry.indexOf(true) === -1;
    const titleWidth = 140;
    const errorLeft = 20 + titleWidth;

    return (
      <div style={{ width: 768, maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, alignItems: 'center', display: 'flex', flexDirection: 'column', padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} />

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='類別' haveChange={checkChange('category')} />
              <EAA_Select disabled={disabled} displayBorder list={IAMMClassList} value={returnInputValue(data.category)} onChange={data => this.changeData({ label: 'category', data })} />
            </EAA_ItemContainer>
            {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='項目' haveChange={checkChange('project')} />
              <EAA_Select disabled={disabled} displayBorder list={IAMMItemList} value={returnInputValue(data.project)} onChange={data => this.changeData({ label: 'project', data })} />
            </EAA_ItemContainer>
            {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='細項' haveChange={checkChange('detailitem')} />
              <EAA_Select disabled={disabled} displayBorder list={['細項1', '細項2'].map(o => ({ name: o, value: o }))} value={returnInputValue(data.detailitem)} onChange={data => this.changeData({ label: 'detailitem', data })} />
            </EAA_ItemContainer>
            {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='辦理情形' haveChange={checkChange('situation')} />
              <EAA_Input disabled={disabled} displayBorder value={returnInputValue(data.situation)} onChange={data => this.changeData({ label: 'situation', data })} />
            </EAA_ItemContainer>
            {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='發文日期' haveChange={checkChange('public_date')} />
              <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.public_date)} onChange={data => this.changeData({ label: 'public_date', data: getTime.getType3Time(data) })} />
            </EAA_ItemContainer>
            {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='文號' haveChange={checkChange('doc_num')} />
              <EAA_Input disabled={disabled} displayBorder value={returnInputValue(data.doc_num)} onChange={data => this.changeData({ label: 'doc_num', data })} />
            </EAA_ItemContainer>
            {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='公文主旨' haveChange={checkChange('doc_subject')} />
              <EAA_Memo disabled={disabled} displayBorder value={returnInputValue(data.doc_subject)} onChange={data => this.changeData({ label: 'doc_subject', data })} />
            </EAA_ItemContainer>
            {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
          </EAA_Item>
        </EAA_Row>

        <EAA_Row>
          <EAA_Item>
            <EAA_ItemContainer>
              <EAA_TitleText width={titleWidth} bol text='針對辦理情形' subtitle='檢附佐證資料' subtitleColor='black' />
              <EAA_Upload disabled={disabled} displayBorder value={data.doc_upload_files || []} onChange={data => this.changeData({ label: 'doc_upload_files', data })} />
            </EAA_ItemContainer>
            {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
          </EAA_Item>
        </EAA_Row>

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewIAMeetMeeting' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutIAMeetMeetingIdDetail' />

      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  IAMMClassList: state.data.IAMMClassList,
  IAMMItemList: state.data.IAMMItemList,
  IAMeetMeetingIdDetail: state.data.IAMeetMeetingIdDetail,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions_Wind.clearKey(dispatch, { key }),
  getBaseData: () => {
    Actions_Wind.getIAMMClassList(dispatch);
    Actions_Wind.getIAMMItemList(dispatch);
  },
  getIAMeetMeetingIdDetail: id => Actions_Wind.getIAMeetMeetingIdDetail(dispatch, { id }),
  postAddNewIAMeetMeeting: body => Actions_Wind.postAddNewIAMeetMeeting(dispatch, { body }),
  putIAMeetMeetingIdDetail: (id, body) => Actions_Wind.putIAMeetMeetingIdDetail(dispatch, { id, body }),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
